export default __webpack_public_path__ + "static/media/Antillian Jerkin.280c6944.jpg";